import { Navigate, Outlet } from "react-router-dom";
import { useAuthSession } from "../../../context/AuthContext";

const RoleProtectedRoute = ({ allowedRoles }) => {
  const { status, role, accountType } = useAuthSession();

  if (status === "loading") return null;

  if (status !== "authenticated") {
    return (
      <Navigate
        to={accountType === "partner" ? "/partner/login" : "/admin/login"}
        replace
      />
    );
  }

  if (!allowedRoles.includes(role)) {
    return (
      <Navigate
        to={accountType === "partner" ? "/partner/careteam" : "/admin/dashboard"}
        replace
      />
    );
  }

  return <Outlet />;
};

export default RoleProtectedRoute;
